<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
   import moment from 'moment';

   export default {
      page: {
         title: "Add Booking",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {

         const current_date = moment().format("YYYY-MM-DD");
         return {
            title: "Add Booking",
            items: [
               {
                  text: "Lab",
                  href: "/labs",
               },
               {
                  text: "Bookings",
                  href: `/labs/bookings/${this.$route.params.id}`
               },
               {
                  text: "Add Booking",
                  active: true,
               },
            ],


            booking: {
               id: "",
               collecting_type: "",
               name : "",
               place: "",
               mobile: "",
               email: "",
               country_code: 1,
               pincode: "",
               counter_id: "",
               address_id: "",
               member_id: "",
               default: false,
               tests: [],
               prescriptions: [],
               schedule_name: "",
               is_priority: false,
               booking_date: current_date,
            },
            countries: [],
            members: [],

            prescription_button_name: "Add Prescription",
            today : current_date,


            booking_location: '',
            booking_marker: { position: { lat: null, lng: null } },
            booking_center: { lat: null, lng: null },
            booking_current_place: null,

            booking_mapOptions: {
               disableDefaultUI: true,
            },

            patient_keyword: "",
            patient_visible: false,
            patient_id: '',
            patient_name: "",

            lab_keyword: "",
            lab_visible: false,
            lab_id: '',
            lab_name: "",

            slots: [],
            schedules: [],
            lab_tests: [],
            lab_counters: [],
            token_management_type: "",
            errors: {},
         };
      },
      mounted() {
         this.fetchCountryCodes();
         this.fetchMembers();
         this.fetchLabs();

      },

      methods: {
         //sets the position of marker when dragged
         labHandleMarkerDrag(e) {
            this.booking_marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
         },

         //Moves the map view port to marker
         labPanToMarker() {
            this.$refs.labMapRef.panTo(this.booking_marker.position);
            this.$refs.labMapRef.setZoom(18);
         },

         //Moves the marker to click position on the map
         labHandleMapClick(e) {
            this.booking_marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
            console.log(e);
         },     

         labSetPlace(place) {
            this.booking_current_place = place;
            if(this.booking_current_place) {
               const marker = {
                  lat: this.booking_current_place.geometry.location.lat(),
                  lng: this.booking_current_place.geometry.location.lng(),
               };
               this.booking_center = marker;
               this.booking_marker.position = marker;
               this.booking_location = place.formatted_address;
            }
         },

         fetchCountryCodes() {
            let url = "api/admin/get-countries";         
            this.getToken();
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  console.log(this.$route.params.id);
                  console.log(this.$route.params.type);
                  this.countries = responseData.countries;
               })
               .catch((err) => console.log(err));
         },
         numbersOnly(event) {
            let keyCode = event.keyCode;
            if (keyCode < 48 || keyCode > 57) {
               event.preventDefault();
            }
         },

        fetchMembers() {  
            let url = "api/admin/consultations/getMembers?patient_id=" + this.$route.params.id;         
            this.getToken();
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                    this.members = responseData.members;
                  this.member_visible = true;
                  
                  
               })
               .catch((err) => console.log(err));
         }, 

         addBooking(){

            this.getToken();

            const config = {
               headers: {
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url = "api/admin/lab/addBooking";

            let formData = new FormData();
            formData.append("lab_id", this.lab_id);
            formData.append("collecting_type", this.booking.collecting_type);
            formData.append("patient_id", this.$route.params.id); 
            formData.append("member_id", this.booking.member_id);
            formData.append("booking_date", this.booking.booking_date);

            let slot = '';

            if(this.booking.collecting_type !== 3){

               if(this.booking.booking_slot) {
                  slot = this.booking.booking_slot.split("-"); 
               }

               formData.append("start_time", slot[0]??"");
               formData.append("end_time", slot[1]??"");
               formData.append('tests', JSON.stringify(this.booking.tests));
               this.booking.prescriptions.forEach((file) => {
                  formData.append('prescriptions[]', file);
               });

            }

            if(this.booking.collecting_type == 1){
               formData.append("token", slot[3]??"");
            } else if(this.booking.collecting_type == 2){
               formData.append("name", this.booking.name);
               formData.append("country_code", this.booking.country_code);
               formData.append("mobile", this.booking.mobile);
               formData.append("email", this.booking.email);
               formData.append("address", this.booking.address);
               formData.append("house_no", this.booking.house_no);
               formData.append("map_location", this.booking_location);
               formData.append("pincode", this.booking.pincode); 
               formData.append("latitude", this.booking_marker.position.lat);
               formData.append("longitude", this.booking_marker.position.lng);
               formData.append("address_id", this.booking.address_id);
               formData.append("default", +this.booking.default);
               formData.append("schedule_name", this.booking.schedule_name);
            } else {
               formData.append("is_priority", this.booking.is_priority);
               if(this.booking.is_priority === true){
                  formData.append("counter_id", this.booking.counter_id);
               }
            }
            
            this.$axios
               .post(url, formData, config)
               .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  //this.$router.push({ name: 'labs.bookings', params: { id: this.$route.params.id } });
               this.$router.push({ name: "patients.lab_bookings", params: { id: this.$route.params.id } });
               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        if(error.response.status == 422);{
                           this.$nextTick(() => {
                              const firstErrorField = document.querySelector('.is-invalid');
                              if (firstErrorField) {
                                 firstErrorField.scrollIntoView({ behavior: 'smooth', block: 'center' });
                                 firstErrorField.focus();
                              }
                           });
                        }
                        //console.log(this.errors);
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));

         },

         fetchLabs() { 
            let url = "api/admin/lab/getLabs?keyword=" + this.lab_keyword;         
            //let url = "api/admin/lab/index?limit=" + this.limit + "&status=" + this.status + "&search=" + this.keyword;

            this.getToken();
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.lab_visible = true;
                  this.labs = responseData.labs;
                   
                    console.log(this.labs);
               })
               .catch((err) => console.log(err));
            
         },

      

         fetchSchedules() { 
            if(this.$route.params.id) {
               
               let url_param = `lab_id=${this.$route.params.id}&booking_date=${this.booking.booking_date}`;
               let url = '';

               if (this.booking.collecting_type == 1) {
               url = `api/admin/lab/collect_lab?${url_param}`;
               } else {
               url = `api/admin/lab/collect_home?${url_param}`;
               }       
               this.getToken();
               this.$axios
                  .get(url, { headers: { Authorization: "Bearer " + this.token } })
                  .then((res) => {
                     var responseData = res.data.data;
                     console.log(responseData);

                     this.schedules = responseData.schedules;
                     this.slots = responseData.slots; 
                     this.lab_tests = responseData.lab.tests;
                     console.log('lab_tests', this.lab_tests);
                  })
                  .catch((err) => console.log(err));
            }
         },

         fetchPatientAddresses() {
            let url = "api/admin/pharmacy/orders/get_address?patient_id=" +  this.$route.params.id;
            this.getToken();
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  if(!responseData.details){
                     this.booking.name = this.patient_name;
                  }
                  this.patient_address = responseData.details;
                  this.booking.name = this.patient_address.name;
                  this.booking.mobile = this.patient_address.phone;
                  this.booking.email = this.patient_address.email;
                  this.booking.country_code = this.patient_address.country_code;
                  this.booking.address = this.patient_address.address;
                  this.booking.house_no = this.patient_address.flat;
                  this.booking.pincode = this.patient_address.pincode;
                  this.booking.address_id = this.patient_address.id;
                  this.booking_location = this.patient_address.map_location;
                  this.booking.default = !!this.patient_address.default;
                  this.booking_marker.position.lat = parseFloat(this.patient_address.latitude);
                  this.booking_marker.position.lng = parseFloat(this.patient_address.longitude); 
                  this.booking_center.lat = parseFloat(this.patient_address.latitude);
                  this.booking_center.lng = parseFloat(this.patient_address.longitude); 
               })
               .catch((err) => console.log(err));
         },

         fetchLabCounters(){
            let url = "api/admin/lab/counters?lab_id=" + this.lab_id;
            this.getToken();
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.lab_counters = responseData;
               })
               .catch((err) => console.log(err));
         },

         detailsFetch() {

            if([1,2].includes(this.booking.collecting_type) && this.booking.booking_date){
               this.fetchSchedules();
            }

            if(this.booking.collecting_type == 2){
               this.fetchPatientAddresses()
            } else if(this.booking.collecting_type !== 1){
               this.fetchLabCounters();
            }
         
         },

         handleScheduleName(test){
            this.booking.schedule_name = test.schedule_name;
         },
         
         getToken() {
            if (localStorage.getItem('medicino_admin')) {
               var medicino_admin =  JSON.parse(localStorage.getItem('medicino_admin'));
               if(medicino_admin.token) {
                  this.token = medicino_admin.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         },

         setLab(lab_id) {
            const selected = this.labs.find(p => p.id === lab_id);
            if (selected) {
               this.lab_name = selected.name;
               this.lab_keyword = `${selected.name}`;
               this.token_management_type = `${selected.token_management_type}`;
               if(this.token_management_type != 1){
                  this.booking.collecting_type = 3;
               }
            }
            this.lab_visible = false;
            //this.fetchMembers(); 

            //console.log('Patient Name', this.patient_name);
         },

         onClickOutside() {
            //console.log("clicked outside");
            if(!this.lab_id){
               this.lab_keyword = '';
               this.lab_visible = false;
            }
         
         },
         
         addPrescriptionInput() {
            this.booking.prescriptions.push(null);
            this.changePrescriptionButtonName();
         },
         
         removePrescriptionInput(index) {
            this.booking.prescriptions.splice(index, 1);
            this.changePrescriptionButtonName();
         },

         changePrescriptionButtonName() {
            this.prescription_button_name = this.booking.prescriptions.length > 0 ? "Add Another Prescription" : "Add Prescription";
         },
         
         isTestSelected(testId) {
            return this.booking.tests.some(t => t.id === testId);
         },
         
         toggleTest(test) {
            const index = this.booking.tests.findIndex(t => t.id === test.id);
            if (index > -1) {
               this.booking.tests.splice(index, 1);
            } else {
               this.booking.tests.push({
               id: test.id,
               price: test.price
               });
            }
            console.log(this.booking.tests);
         },

         handlePriorityChange(value) {
            if(value === true){
               this.fetchLabCounters();
            }
         }
      }
   }
</script>

    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">

                  <!----- top button area starts---->
                  <div class="row mb-2">
                     <div class="col-12">
                        <router-link :to="{ name: 'patients.lab_bookings', params:{ id:$route.params.id }  }" class="btn btn-primary float-end ms-2"><i class='bx bx-chevrons-left'></i> Back</router-link>
                     </div>
                  </div>
                  <!----- top button area ends---->
                  <b-card header-class="bg-transparent border-light" class="border border-light">
                     <form class="form-horizontal" role="form" @submit.prevent="addBooking()">
                        
                        <div class="row">
                          

                         

                          <b-col md="12" lg="6" class="form-group" v-click-outside="onClickOutside">
                              <label class="control-label">Lab <span class="text-danger">*</span></label>
                              <b-form-input ref="labInput" v-model="lab_keyword"   @keyup="fetchLabs()" 
                                 @click="fetchLabs()"  autocomplete="off" placeholder="Search here..." v-bind:class="{ 'is-invalid': Boolean(errors.lab_id) }">
                              </b-form-input>
                              <b-form-select class="form-control" v-if="lab_visible && Boolean(labs.length)" v-model="lab_id" :select-size="labs.length < 10 ? (labs.length <= 1 ? 2 : labs.length) : 10" @change="setLab">
                                 <b-form-select-option v-for="lab in labs" :key="lab.id" :value="lab.id"> {{lab.name}} </b-form-select-option>
                              </b-form-select>

                              <b-form-select class="form-control" v-if="lab_visible && !Boolean(labs.length)" v-model="lab_id" :select-size="2">                  
                                    <b-form-select-option :value="0" disabled>No data results...</b-form-select-option>
                              </b-form-select>
                              <div v-for="(val, index) in errors.lab_id" :key="index" class="invalid-feedback d-block">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <b-col md="12" lg="6" class="form-group" v-if="this.lab_id">
                              <label class="control-label">Collecting Type <span class="text-danger">*</span></label>
                              <b-form-radio-group
                                 v-model="booking.collecting_type"
                                 name="labTokenType"
                                 :class="{ 'is-invalid': Boolean(errors.collecting_type) }"
                                 inline
                                 @change="detailsFetch()"
                                 >
                                 <div v-if="this.token_management_type == 1">
                                    <div class="form-check-inline">
                                    <b-form-radio :value="1">Lab</b-form-radio>
                                    </div>
                                    <div class="form-check-inline">
                                    <b-form-radio :value="2" @click="fetchPatientAddresses()">Home</b-form-radio>
                                    </div>
                                 </div>
                                 <div v-else>
                                    <div class="form-check-inline">
                                    <b-form-radio :value="3">Counter</b-form-radio>
                                    </div>
                                 </div>
                              </b-form-radio-group>

                              <div v-for="(val, index) in errors.collecting_type" :key="index" class="invalid-feedback d-block">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <b-col md="12" lg="6" class="form-group" v-if="this.token_management_type == 1 && lab_id">
                              <label class="control-label">Booking Date <span class="text-danger">*</span></label>
                              <b-form-input type="date" v-model="booking.booking_date" @change="booking.collecting_type == 1 || booking.collecting_type == 2 ? fetchSchedules() : ''" v-bind:class="{ 'is-invalid': Boolean(errors.booking_date) }" :min="today"></b-form-input>
                              <div v-for="(val, index) in errors.booking_date" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <b-col md="12" lg="6" class="form-group" v-if="this.token_management_type != 1 && lab_id">
                            <label>Booking Date <span class="text-danger">*</span></label>
                            <input type="date" class="form-control" v-model="booking.booking_date" readonly />
                         </b-col>
                        </div>
                        <div v-if="booking.collecting_type == 3 && booking.booking_date">
                           <div class="row">
                           <b-col md="12" lg="6" class="form-group" >
                                 <label>Is Priority <span class="text-danger">*</span></label>
                                 <b-form-radio-group v-model="booking.is_priority" @change="handlePriorityChange" v-bind:class="{ 'is-invalid': Boolean(errors.is_priority) }">
                                    <div class="d-flex gap-4">
                                       <b-form-radio :value="true">Yes</b-form-radio>
                                       <b-form-radio :value="false">No</b-form-radio>
                                    </div>
                                 </b-form-radio-group>
                                 <div v-for="(val, index) in errors.is_priority" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                              </b-col>
                              <b-col md="12" lg="6" class="form-group" v-if="booking.is_priority == true">
                                 <label>Counter <span class="text-danger">*</span></label>
                                 <select class="form-control" v-model="booking.counter_id" v-bind:class="{ 'is-invalid': Boolean(errors.counter_id) }">
                                    <option value="">Select Counter</option>
                                    <option :value="counter.id" v-for="counter in lab_counters" :key="counter.id">{{counter.counter_name}}</option>
                                 </select>
                                 <div v-for="(val, index) in errors.counter_id" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                              </b-col>
                           </div>
                        </div>

                          <b-col md="12" lg="6" class="form-group" v-if="this.token_management_type == 1 && this.lab_id ">
                              <label>Consultation For <span class="text-danger">*</span></label>
                              <select class="form-control" v-model="booking.member_id" v-bind:class="{ 'is-invalid': Boolean(errors.consultation_for) }">
                                 <option value="">Self</option>
                                 <option :value="member.id" v-for="member in members" :key="member.id">{{member.name}}</option>
                              </select>
                           </b-col>

                        <div class="row" v-if="(booking.collecting_type === 1 || booking.collecting_type === 2) && booking.booking_date">
                           <b-col md="12" class="form-group" >
                              <div v-if="slots.length" v-bind:class="{ 'is-invalid': Boolean(errors.start_time) }">
                                 <label class="w-100">Pick your slot <span class="text-danger">*</span></label>
                                 <b-form-radio-group 
                                    v-model="booking.booking_slot"
                                    name="booking_slot"
                                    buttons
                                    button-variant="outline-primary"
                                    size="sm"
                                    class="slots"
                                 >  
                                    <div class="d-flex flex-wrap gap-3">
                                       <b-form-radio v-for="(slot, index) in slots" @change="booking.collecting_type == 2 ? handleScheduleName(slot) : ''" :key="index" :value="slot.start + '-' + slot.stop + '-' + slot.schedule_id + '-' + slot.token + '-' + slot.schedule_start + '-' + slot.schedule_end "  :disabled="!slot.slot_available || slot.dnone" class="px-3 py-2 rounded">{{slot.start | formatTime}} - {{slot.stop | formatTime}}</b-form-radio>  
                                    </div>
                                 </b-form-radio-group>
                              </div>
                              <div v-else>
                                 <p class="text-danger">No available slots</p>
                              </div>
                              <div v-for="(val, index) in errors.start_time" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>  
                           </b-col>
                           <b-col md="12" class="form-group" >
                              <div v-if="lab_tests.length" :class="{ 'is-invalid': Boolean(errors.session_id) }">
                                 <label class="w-100">Choose Lab Tests <span class="text-danger">*</span></label>

                                 <div class="d-flex flex-wrap gap-3">
                                    <div v-for="(test, index) in lab_tests" :key="index" class="form-check">
                                       <input
                                       class="form-check-input"
                                       type="checkbox"
                                       :id="'lab_test_' + test.id"
                                       :value="test.id"
                                       :checked="isTestSelected(test.id)"
                                       @change="toggleTest(test)"
                                       style="width: 20px; height: 20px;"
                                       />
                                       <label class="form-check-label lg"  style="padding-left: 8px; font-weight: 500;" :for="'lab_test_' + test.id">
                                       {{ test.name }}
                                       </label>
                                    </div>
                                 </div>
                              </div>
                              <div v-else>
                                 <p class="text-danger">No available lab tests</p>
                              </div>
                              
                              <div v-for="(val, index) in errors.session_id" :key="index" class="invalid-feedback d-block">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>
                           <b-col md="12" class="form-group">
                              <div :class="{ 'is-invalid': Boolean(errors.pre) }">
                                 <label class="w-100 mb-2">Add Prescriptions <span class="text-danger">*</span></label>

                                 <div class="d-flex flex-wrap gap-3">
                                    <div v-for="(file, index) in booking.prescriptions" class="d-flex align-items-center mb-2" :key="index">
                                       <b-button
                                          variant="outline-danger"
                                          size="sm"
                                          @click="removePrescriptionInput(index)"
                                          title="Remove this file"
                                          class="me-2"
                                       >
                                          &times;
                                       </b-button>
                                       <b-form-file
                                       v-model="booking.prescriptions[index]"
                                       :state="Boolean(booking.prescriptions[index])"
                                       placeholder="Choose a prescription file..."
                                       browse-text="Browse"
                                       accept=".jpg,.jpeg,.png,.pdf"
                                       ></b-form-file>
                                    </div>
                                 </div>
                                 <b-button variant="outline-primary" size="sm" @click="addPrescriptionInput">
                                    {{ prescription_button_name }}
                                 </b-button>
                              </div>

                              <div
                                 v-for="(val, index) in errors.pre"
                                 :key="index"
                                 class="invalid-feedback d-block"
                              >
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>
                        </div>

                        <div v-if="booking.collecting_type == 2 && booking.booking_date && this.$route.params.id">
                           <div class="row">

                              <b-col md="12" lg="6" class="form-group">
                                 <label class="control-label">Name <span class="text-danger">*</span></label>
                                 <b-form-input v-model="booking.name" v-bind:class="{ 'is-invalid': Boolean(errors.name) }"></b-form-input>
                                 <div v-for="(val, index) in errors.name" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                              </b-col>

                              <b-col md="12" lg="6" class="form-group">
                                 <label class="control-label">Phone <span class="text-danger">*</span></label>
                                 <b-input-group>
                                    <b-input-group-prepend>
                                       <select class="form-control" v-model="booking.country_code"  v-bind:class="{ 'is-invalid': Boolean(errors.country_code) }">
                                          <option :value="country.id" v-for="country in countries" :key="country.id">{{country.country_code}}</option>
                                       </select>
                                    </b-input-group-prepend>
                                    <b-form-input v-model="booking.mobile" maxlength="15" @keypress="numbersOnly" v-bind:class="{ 'is-invalid': Boolean(errors.mobile) }"></b-form-input>
                                    <div v-for="(val, index) in errors.country_code" :key="index" class="invalid-feedback">
                                       <p class="mb-0">{{ val }}</p>
                                    </div>
                                    <div v-for="(val, index) in errors.mobile" :key="index" class="invalid-feedback">
                                       <p class="mb-0">{{ val }}</p>
                                    </div>
                                 </b-input-group>
                              </b-col>

                              <b-col md="12" lg="6" class="form-group">
                                 <label class="control-label">Email <span class="text-danger">*</span></label>
                                 <b-form-input v-model="booking.email" v-bind:class="{ 'is-invalid': Boolean(errors.email) }"></b-form-input>
                                 <div v-for="(val, index) in errors.email" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                              </b-col>

                              <b-col md="12" lg="6" class="form-group">
                                 <label class="control-label">Address <span class="text-danger">*</span></label>
                                 <b-form-input v-model="booking.address" v-bind:class="{ 'is-invalid': Boolean(errors.address) }"></b-form-input>
                                 <div v-for="(val, index) in errors.address" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                              </b-col>

                              <b-col md="12" lg="6" class="form-group">
                                 <label class="control-label">House No <span class="text-danger">*</span></label>
                                 <b-form-input v-model="booking.house_no" v-bind:class="{ 'is-invalid': Boolean(errors.house_no) }"></b-form-input>
                                 <div v-for="(val, index) in errors.house_no" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                              </b-col>

                              <div class="form-group col-md-6">
                                 <label>Pin Number <span class="text-danger">*</span></label>
                                 <b-form-input v-model="booking.pincode" @keypress="numbersOnly" autocomplete="off" maxlength="6" v-bind:class="{ 'is-invalid': Boolean(errors.pincode) }"></b-form-input>

                                 <div v-for="(val, index) in errors.pincode" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                              </div>

                              <b-col md="12" class="mb-3">
                                 <label class="control-label">Location <span class="text-danger">*</span></label>
                                 <GmapAutocomplete @place_changed="labSetPlace" class="form-control"  @keypress.enter="$event.preventDefault()" placeholder="Search here..."  :value="booking_location"/>
                                 
                                 <GmapMap
                                    :center="booking_center"
                                    :zoom="18"
                                    map-style-id="lab-roadmap"
                                    :options="booking_mapOptions"
                                    style="width: 100%; height: 50vmin"
                                    ref="labMapRef"
                                    @click="labHandleMapClick">
                                       <GmapMarker
                                          :position="booking_marker.position"
                                          :clickable="true"
                                          :draggable="true"
                                          @drag="labHandleMarkerDrag"
                                          @click="labPanToMarker"
                                       />
                                 </GmapMap>                          
                              </b-col>

                              <b-col md="6" xl="6" class="form-group">
                                 <label class="control-label">Latitude <span class="text-danger">*</span></label>
                                 <b-form-input v-model="booking_marker.position.lat" v-bind:class="{ 'is-invalid': Boolean(errors.latitude) }"></b-form-input>
                                 <div v-for="(val, index) in errors.latitude" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                              </b-col>

                              <b-col md="6" xl="6" class="form-group">
                                 <label class="control-label">Longitude <span class="text-danger">*</span></label>
                                 <b-form-input v-model="booking_marker.position.lng" v-bind:class="{ 'is-invalid': Boolean(errors.longitude) }"></b-form-input>
                                 <div v-for="(val, index) in errors.longitude" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                              </b-col>

                              <b-col md="6" xl="6" class="form-group">
                                 <label class="control-label">Make this as default address <span class="text-danger">*</span></label>
                                 <b-form-checkbox v-model="booking.default" v-bind:class="{ 'is-invalid': Boolean(errors.default) }"></b-form-checkbox>
                                 <div v-for="(val, index) in errors.default" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                              </b-col>
                           </div>
                        </div>
                        

                        <div class="row mt-3">
                           <div class="12">
                              <button class="btn btn-primary me-2" type="submit">Save</button>
                              <router-link :to="{ name: 'labs.bookings', params: {id: this.$route.params.id} }" class="btn btn-light">Cancel</router-link>
                           </div>
                        </div>
                     </form>
                  </b-card>
               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
